module.exports = __webpack_public_path__ + "static/media/warcry.6649b37d.png";